import { Link, Text } from '@radix-ui/themes'
import { getAddressUrl } from 'app/explorer-config'
import { useGetSmartContract } from 'shared/hooks/use-smart-contracts'
import { LinkIcon } from 'shared/icons'
import styles from '../balance-add.module.scss'

export const MintDialogLink = () => {
  const { smartContractAddress } = useGetSmartContract('USDC')

  return (
    <Link
      className={styles.mintContractLink}
      target={'_blank'}
      href={getAddressUrl(smartContractAddress)}
    >
      <Text>View contract</Text>
      <LinkIcon />
    </Link>
  )
}
